import React from "react";
import { useUser } from "../../classes/contexts/UserContext";
import { formatDateWithTimeInZone } from "../../classes/utils/DateUtils";
import { useKeyboardActivation } from "../../hooks/useKeyboardActivation";

import "./ClinicalHistoryThumbnail.css";

const ClinicalHistoryThumbnail = ({ history, isSelected, onClick }) => {
  const { userPreferences, dateSettings } = useUser();
  const timeZone =
    userPreferences?.display_settings?.timezone?.toString() || "UTC";
  const formattedDate = formatDateWithTimeInZone(
    history?.createdAt || history?.updatedAt,
    timeZone,
    { locale: dateSettings?.locale }
  );

  // Get a summary indicator based on which fields are populated
  const getCompleteness = () => {
    let count = 0;
    if (history.weight) count++;
    if (history.height) count++;
    if (history.conditions) count++;
    if (history.note) count++;
    return count;
  };

  const completeness = getCompleteness();

  // Color based on completeness (similar to pain assessment gradient)
  const getColor = () => {
    const rootStyles = getComputedStyle(document.documentElement);
    if (completeness >= 4) {
      return rootStyles.getPropertyValue("--MDsim-gradient-dark-green").trim();
    } else if (completeness >= 3) {
      return rootStyles.getPropertyValue("--MDsim-gradient-light-green").trim();
    } else if (completeness >= 2) {
      return rootStyles.getPropertyValue("--MDsim-gradient-yellow").trim();
    } else {
      return rootStyles.getPropertyValue("--MDsim-gradient-orange").trim();
    }
  };

  const color = getColor();

  return (
    <div
      className={`clinical-history-thumbnail ${isSelected ? "selected" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={useKeyboardActivation(onClick)}
      style={{
        borderColor: color,
        borderWidth: isSelected ? "3px" : "2px",
        borderStyle: "solid",
      }}
    >
      <div
        className="clinical-history-thumbnail-color"
        style={{
          backgroundColor: `${color}50`,
        }}
      >
        <div className="clinical-history-thumbnail-info">
          <div className="clinical-history-thumbnail-date">{formattedDate}</div>
          <div className="clinical-history-thumbnail-level">
            {completeness}/4
          </div>
        </div>
      </div>

      {isSelected && <div className="clinical-history-thumbnail-marker">&#10003;</div>}
    </div>
  );
};

export default ClinicalHistoryThumbnail;
